import { History } from "history";
import * as React from "react";
import { connect } from "react-redux";
import LoadingSpinner from "src/shared/LoadingSpinner";
import { getSSORedirectUrl } from "../login/selector";
import selectorsToProps from "../utils/selectorsToProps";
import "./LoggedOutForm.scss";
import { getSSOApiUrl, getSSOClientId } from "./selector";

interface LoginProps {
  history: History;
  ssoRedirectUrl: string;
  ssoBaseUrl: string;
  ssoClientId: string;
}

interface LoginState {
  authType: string;
}

export class LoginWithSSO extends React.Component<LoginProps, LoginState> {
  constructor(props: LoginProps) {
    super(props);

    this.state = {
      authType: ""
    };
  }

  public componentDidMount() {
    // tslint:disable-next-line: no-console
    console.log("Got here.");
    // tslint:disable-next-line: no-console
    console.log(
      `${this.props.ssoBaseUrl}/sso-api/auth/authorization?client_id=${this.props.ssoClientId}&response_type=code&scope=openid&redirect_uri=${this.props.ssoRedirectUrl}`
    );
    window.location.href = `${this.props.ssoBaseUrl}/sso-api/auth/authorization?client_id=${this.props.ssoClientId}&response_type=code&scope=openid&redirect_uri=${this.props.ssoRedirectUrl}`;
    // tslint:disable-next-line: no-console
    console.log("Got past login_sso redirect.");
  }
  public render() {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }
}

export default connect(
  selectorsToProps({
    ssoRedirectUrl: getSSORedirectUrl,
    ssoBaseUrl: getSSOApiUrl,
    ssoClientId: getSSOClientId
  })
)(LoginWithSSO);



// WEBPACK FOOTER //
// ./src/login/LoginWithSSO.tsx